<template>
  <div>
    <v-btn @click="createPPT()" :disabled="disableBtn">PPTX NL</v-btn>
  </div>
</template>

<script>
import defaultSlide from "@/mixin/defaultSlide";
import { mapGetters } from "vuex";
import FirstPageRectangle from "@/json/PowerPoint/FirstPageRectangle.json";
import FontFirstPageHeader from "@/json/PowerPoint/FontFirstPageTitle.json";
import FontLegendaHead from "@/json/PowerPoint/FontLegendaHead.json";
import FontLegendaText from "@/json/PowerPoint/FontLegendaText.json";
import FontLegendaTextBlock from "@/json/PowerPoint/FontTextBlock.json";
import FontLegendaTextBlockXL from "@/json/PowerPoint/FontTextBlockXL.json";
import FontTitleBig from "@/json/PowerPoint/FontTitleBig.json";
import FontTitleSmall from "@/json/PowerPoint/FontTitleSmall.json";
import GraphChart from "@/json/PowerPoint/GraphChart.json";
import PlaceFirstPageTitle from "@/json/PowerPoint/PlaceFistPageTitle.json";
import PlaceLegenda from "@/json/PowerPoint/PlaceLegenda.json";
import PlaceTextBlock from "@/json/PowerPoint/PlaceTextBlock.json";
import PlaceTextBlockXL from "@/json/PowerPoint/PlaceTextBlockXL.json";
import TitlePlace from "@/json/PowerPoint/PlaceTitle.json";
import TableOptions from "@/json/PowerPoint/TableOptions.json";
import TableOptionsRemark from "@/json/PowerPoint/TableOptionsRemark.json";
import FontFirstPageSubHeader from "@/json/PowerPoint/FontFirstPageSubHeader.json";
import FontFirstPageThreeHeader from "@/json/PowerPoint/FontFirstPageThreeHeader.json";
import PlaceFirstPageSubHeader from "@/json/PowerPoint/PlaceFirstPageSubHeader.json";
import PlaceFirstPageThreeHeader from "@/json/PowerPoint/PlaceFirstPageThreeHeader.json";
import textA from "@/json/Fchart/Report/textC.json";
import FchartService from "@/services/fchart/FchartService";
export default {
  name: "ReportC",
  components: {},
  mixins: [defaultSlide],

  data() {
    return {
      disableBtn: false,
      textModule: textA,
      firstPageRectangle: FirstPageRectangle,
      fontFirstPageHeader: FontFirstPageHeader,
      LegendaKop: FontLegendaHead,
      LegendaTekst: FontLegendaText,
      TextBlock: FontLegendaTextBlock,
      TextBlockXL: FontLegendaTextBlockXL,
      gTitle: FontTitleBig,
      gTitleSmall: FontTitleSmall,
      optionsGraph: GraphChart,
      placeFirstPageTitle: PlaceFirstPageTitle,
      TextBlockLegenda: PlaceLegenda,
      TextBlockPlace: PlaceTextBlock,
      TextBlockPlaceXL: PlaceTextBlockXL,
      gTitlePlace: TitlePlace,
      optTable: TableOptions,
      optTableRemark: TableOptionsRemark,
      placeFirstPageThreeHeader: PlaceFirstPageThreeHeader,
      placeFirstPageSubHeader: PlaceFirstPageSubHeader,
      fontFirstPageSubHeader:FontFirstPageSubHeader,
      fontFirstPageThreeHeader: FontFirstPageThreeHeader,
      dataext: null,
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.famId;
      this.loading = true;
      FchartService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    createPPT() {
      // eslint-disable-next-line no-undef
      let pres = new pptxgen();
      this.disableBtn = true;
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);


      // deenition variables
      let k = this.cstoremodules.length;
      let l = k - 1;
      let namen = [];
      let statMemberDataA = [];
      let statMemberDataB = [];
      let statMemberDataC = [];
      let statMemberDataD = [];
      let statMemberDataE = [];
      let statMemberDataF = [];
      let statMemberDataG = [];
      let statMemberDataH = [];
      let statMemberDataI = [];
      let statMemberDataJ = [];
      let statMemberDataK = [];
      let statMemberDataL = [];
      let statMemberDataM = [];
      let statMemberDataN = [];
      let statMemberDataO = [];
      let statMemberDataP = [];
      let statMemberDataQ = [];
      let statMemberDataR = [];
      let statMemberDataS = [];
      let statMemberDataT = [];
      let statMemberDataU = [];
      let statMemberDataV = [];
      let statMemberDataW = [];
      let statMemberDataX = [];
      let statMemberDataY = [];
      let statMemberDataZ = [];
      let statMemberDataZA = [];
      let statMemberDataZB = [];
      let statMemberDataZC = [];
      let statMemberDataZD = [];
      let statMemberDataZE = [];
      let statMemberDataZF = [];
      let statMemberDataZG = [];
      let statMemberDataZH = [];
      let statMemberDataZI = [];
      let statMemberDataZJ = [];
      let statMemberDataZK = [];
      let statMemberDataZL = [];
      let statMemberDataZM = [];
      let statMemberDataZN = [];
      let statMemberDataZO = [];
      let statMemberDataZP = [];

      // remarks
      let remarkDataA = [];
      let remarkDataB = [];
      let remarkDataC = [];
      let remarkDataD = [];
      let remarkDataE = [];
      let remarkDataF = [];
      let remarkDataG = [];
      let remarkDataH = [];
      let remarkDataI = [];

      for (let m = 0; m <= l; m++) {
        namen.push(this.cstoremodules[m].first_name);
        statMemberDataA.push(this.cstoremodules[m].cfsmodule.sl_a);
        statMemberDataB.push(this.cstoremodules[m].cfsmodule.sl_b);
        statMemberDataC.push(this.cstoremodules[m].cfsmodule.sl_c);
        statMemberDataD.push(this.cstoremodules[m].cfsmodule.sl_d);
        statMemberDataE.push(this.cstoremodules[m].cfsmodule.sl_e);
        statMemberDataF.push(this.cstoremodules[m].cfsmodule.sl_f);
        statMemberDataG.push(this.cstoremodules[m].cfsmodule.sl_g);
        statMemberDataH.push(this.cstoremodules[m].cfsmodule.sl_h);
        statMemberDataI.push(this.cstoremodules[m].cfsmodule.sl_i);
        statMemberDataJ.push(this.cstoremodules[m].cfsmodule.sl_j);
        statMemberDataK.push(this.cstoremodules[m].cfsmodule.sl_k);
        statMemberDataL.push(this.cstoremodules[m].cfsmodule.sl_l);
        statMemberDataM.push(this.cstoremodules[m].cfsmodule.sl_m);
        statMemberDataN.push(this.cstoremodules[m].cfsmodule.sl_n);
        statMemberDataO.push(this.cstoremodules[m].cfsmodule.sl_o);
        statMemberDataP.push(this.cstoremodules[m].cfsmodule.sl_p);
        statMemberDataQ.push(this.cstoremodules[m].cfsmodule.sl_q);
        statMemberDataR.push(this.cstoremodules[m].cfsmodule.sl_r);
        statMemberDataS.push(this.cstoremodules[m].cfsmodule.sl_s);
        statMemberDataT.push(this.cstoremodules[m].cfsmodule.sl_t);
        statMemberDataU.push(this.cstoremodules[m].cfsmodule.sl_u);
        statMemberDataV.push(this.cstoremodules[m].cfsmodule.sl_v);
        statMemberDataW.push(this.cstoremodules[m].cfsmodule.sl_w);
        statMemberDataX.push(this.cstoremodules[m].cfsmodule.sl_x);
        statMemberDataY.push(this.cstoremodules[m].cfsmodule.sl_y);
        statMemberDataZ.push(this.cstoremodules[m].cfsmodule.sl_z);
        statMemberDataZA.push(this.cstoremodules[m].cfsmodule.sl_za);
        statMemberDataZB.push(this.cstoremodules[m].cfsmodule.sl_zb);
        statMemberDataZC.push(this.cstoremodules[m].cfsmodule.sl_zc);
        statMemberDataZD.push(this.cstoremodules[m].cfsmodule.sl_zd);
        statMemberDataZE.push(this.cstoremodules[m].cfsmodule.sl_ze);
        statMemberDataZF.push(this.cstoremodules[m].cfsmodule.sl_zf);
        statMemberDataZG.push(this.cstoremodules[m].cfsmodule.sl_zg);
        statMemberDataZH.push(this.cstoremodules[m].cfsmodule.sl_zh);
        statMemberDataZI.push(this.cstoremodules[m].cfsmodule.sl_zi);
        statMemberDataZJ.push(this.cstoremodules[m].cfsmodule.sl_zj);
        statMemberDataZK.push(this.cstoremodules[m].cfsmodule.sl_zk);
        statMemberDataZL.push(this.cstoremodules[m].cfsmodule.sl_zl);
        statMemberDataZM.push(this.cstoremodules[m].cfsmodule.sl_zm);
        statMemberDataZN.push(this.cstoremodules[m].cfsmodule.sl_zn);
        statMemberDataZO.push(this.cstoremodules[m].cfsmodule.sl_zo);
        statMemberDataZP.push(this.cstoremodules[m].cfsmodule.sl_zp);

        remarkDataA.push(this.cstoremodules[m].cfsmodule.remark_a);
        remarkDataB.push(this.cstoremodules[m].cfsmodule.remark_b);
        remarkDataC.push(this.cstoremodules[m].cfsmodule.remark_c);
        remarkDataD.push(this.cstoremodules[m].cfsmodule.remark_d);
        remarkDataE.push(this.cstoremodules[m].cfsmodule.remark_e);
        remarkDataF.push(this.cstoremodules[m].cfsmodule.remark_f);
        remarkDataG.push(this.cstoremodules[m].cfsmodule.remark_g);
        remarkDataH.push(this.cstoremodules[m].cfsmodule.remark_h);
        remarkDataI.push(this.cstoremodules[m].cfsmodule.remark_i);
      }
      ///slider
      let arrayStatementA = [{ name: "StatementA", labels: namen, values: statMemberDataA }];
      let arrayStatementB = [{ name: "StatementB", labels: namen, values: statMemberDataB }];
      let arrayStatementC = [{ name: "StatementC", labels: namen, values: statMemberDataC }];
      let arrayStatementD = [{ name: "StatementD", labels: namen, values: statMemberDataD }];
      let arrayStatementE = [{ name: "StatementE", labels: namen, values: statMemberDataE }];
      let arrayStatementF = [{ name: "StatementF", labels: namen, values: statMemberDataF }];
      let arrayStatementG = [{ name: "StatementG", labels: namen, values: statMemberDataG }];
      let arrayStatementH = [{ name: "StatementH", labels: namen, values: statMemberDataH }];
      let arrayStatementI = [{ name: "StatementI", labels: namen, values: statMemberDataI }];
      let arrayStatementJ = [{ name: "StatementJ", labels: namen, values: statMemberDataJ }];
      let arrayStatementK = [{ name: "StatementK", labels: namen, values: statMemberDataK }];
      let arrayStatementL = [{ name: "StatementL", labels: namen, values: statMemberDataL }];
      let arrayStatementM = [{ name: "StatementM", labels: namen, values: statMemberDataM }];
      let arrayStatementN = [{ name: "StatementN", labels: namen, values: statMemberDataN }];
      let arrayStatementO = [{ name: "StatementO", labels: namen, values: statMemberDataO }];
      let arrayStatementP = [{ name: "StatementP", labels: namen, values: statMemberDataP }];
      let arrayStatementQ = [{ name: "StatementQ", labels: namen, values: statMemberDataQ }];
      let arrayStatementR = [{ name: "StatementR", labels: namen, values: statMemberDataR }];
      let arrayStatementS = [{ name: "StatementS", labels: namen, values: statMemberDataS }];
      let arrayStatementT = [{ name: "StatementT", labels: namen, values: statMemberDataT }];
      let arrayStatementU = [{ name: "StatementU", labels: namen, values: statMemberDataU }];
      let arrayStatementV = [{ name: "StatementV", labels: namen, values: statMemberDataV }];
      let arrayStatementW = [{ name: "StatementW", labels: namen, values: statMemberDataW }];
      let arrayStatementX = [{ name: "StatementX", labels: namen, values: statMemberDataX }];
      let arrayStatementY = [{ name: "StatementY", labels: namen, values: statMemberDataY }];
      let arrayStatementZ = [{ name: "StatementZ", labels: namen, values: statMemberDataZ }];
      let arrayStatementZA = [{ name: "StatementZA", labels: namen, values: statMemberDataZA }];
      let arrayStatementZB = [{ name: "StatementZB", labels: namen, values: statMemberDataZB }];
      let arrayStatementZC = [{ name: "StatementZC", labels: namen, values: statMemberDataZC }];
      let arrayStatementZD = [{ name: "StatementZD", labels: namen, values: statMemberDataZD }];
      let arrayStatementZE = [{ name: "StatementZE", labels: namen, values: statMemberDataZE }];
      let arrayStatementZF = [{ name: "StatementZF", labels: namen, values: statMemberDataZF }];
      let arrayStatementZG = [{ name: "StatementZG", labels: namen, values: statMemberDataZG }];
      let arrayStatementZH = [{ name: "StatementZH", labels: namen, values: statMemberDataZH }];
      let arrayStatementZI = [{ name: "StatementZI", labels: namen, values: statMemberDataZI }];
      let arrayStatementZJ = [{ name: "StatementZJ", labels: namen, values: statMemberDataZJ }];
      let arrayStatementZK = [{ name: "StatementZK", labels: namen, values: statMemberDataZK }];
      let arrayStatementZL = [{ name: "StatementZL", labels: namen, values: statMemberDataZL }];
      let arrayStatementZM = [{ name: "StatementZM", labels: namen, values: statMemberDataZM }];
      let arrayStatementZN = [{ name: "StatementZN", labels: namen, values: statMemberDataZN }];
      let arrayStatementZO = [{ name: "StatementZO", labels: namen, values: statMemberDataZO }];
      let arrayStatementZP = [{ name: "StatementZP", labels: namen, values: statMemberDataZP }];

      //remarks
      let arrayRemarkA = [namen, remarkDataA];
      let arrayRemarkB = [namen, remarkDataB];
      let arrayRemarkC = [namen, remarkDataC];
      let arrayRemarkD = [namen, remarkDataD];
      let arrayRemarkE = [namen, remarkDataE];
      let arrayRemarkF = [namen, remarkDataF];
      let arrayRemarkG = [namen, remarkDataG];
      let arrayRemarkH = [namen, remarkDataH];
      let arrayRemarkI = [namen, remarkDataI];

      pres.defineSlideMaster(this.data);
      pres.defineSlideMaster(this.data2);
      pres.defineSlideMaster(this.data3);

      let slide1 = pres.addSlide("FIRST_SLIDE");
      slide1.addShape(pres.ShapeType.rect, this.firstPageRectangle);
      slide1.addText([{ text: "Familiestatuut", options: this.fontFirstPageHeader }], this.placeFirstPageTitle);
      slide1.addText([{ text: this.textModule[0].header, options: this.fontFirstPageSubHeader }], this.placeFirstPageSubHeader);
      slide1.addText([{ text: "Familie " + this.dataext.family_name, options: this.fontFirstPageThreeHeader }], this.placeFirstPageThreeHeader);
      let slide2 = pres.addSlide("MASTER_SLIDE");
      slide2.addText([{ text: this.textModule[0].header, options: this.gTitle }], this.gTitlePlace);
      slide2.addText(
        [
          { text: this.textModule[0].texta, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textb, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textc, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textd, options: this.TextBlockXL },
        ],
        this.TextBlockPlaceXL
      );

      //Part A
      let slide3 = pres.addSlide("MASTER_SLIDE");
      slide3.addText([{ text: this.textModule[1].header, options: this.gTitle }], this.gTitlePlace);
      slide3.addText([{ text: this.textModule[1].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide4 = pres.addSlide("MASTER_SLIDE");
      slide4.addText([{ text: this.statements[0].statement, options: this.gTitle }], this.gTitlePlace);
      slide4.addChart(pres.charts.BAR, arrayStatementA, this.optionsGraph);

      let slide5 = pres.addSlide("MASTER_SLIDE");
      slide5.addText([{ text: this.statements[1].statement, options: this.gTitle }], this.gTitlePlace);
      slide5.addChart(pres.charts.BAR, arrayStatementB, this.optionsGraph);

      let slide6 = pres.addSlide("MASTER_SLIDE");
      slide6.addText([{ text: this.statements[2].statement, options: this.gTitle }], this.gTitlePlace);
      slide6.addChart(pres.charts.BAR, arrayStatementC, this.optionsGraph);

      let slide7 = pres.addSlide("MASTER_SLIDE");
      slide7.addText([{ text: this.statements[3].statement, options: this.gTitle }], this.gTitlePlace);
      slide7.addChart(pres.charts.BAR, arrayStatementD, this.optionsGraph);

      let slide8 = pres.addSlide("MASTER_SLIDE");
      slide8.addText([{ text: this.statements[4].statement, options: this.gTitle }], this.gTitlePlace);
      slide8.addChart(pres.charts.BAR, arrayStatementE, this.optionsGraph);

      let slide9 = pres.addSlide("MASTER_SLIDE");
      slide9.addText([{ text: this.statements[5].statement, options: this.gTitle }], this.gTitlePlace);
      slide9.addChart(pres.charts.BAR, arrayStatementF, this.optionsGraph);

      let slide10 = pres.addSlide("MASTER_SLIDE");
      slide10.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide10.addTable(arrayRemarkA, this.optTableRemark);

      //Part B
      let slide11 = pres.addSlide("MASTER_SLIDE");
      slide11.addText([{ text: this.textModule[2].header, options: this.gTitle }], this.gTitlePlace);
      slide11.addText([{ text: this.textModule[2].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide12 = pres.addSlide("MASTER_SLIDE");
      slide12.addText([{ text: this.statements[6].statement, options: this.gTitle }], this.gTitlePlace);
      slide12.addChart(pres.charts.BAR, arrayStatementG, this.optionsGraph);

      let slide13 = pres.addSlide("MASTER_SLIDE");
      slide13.addText([{ text: this.statements[7].statement, options: this.gTitle }], this.gTitlePlace);
      slide13.addChart(pres.charts.BAR, arrayStatementH, this.optionsGraph);

      let slide14 = pres.addSlide("MASTER_SLIDE");
      slide14.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide14.addTable(arrayRemarkB, this.optTableRemark);

      //Part C
      let slide15 = pres.addSlide("MASTER_SLIDE");
      slide15.addText([{ text: this.textModule[3].header, options: this.gTitle }], this.gTitlePlace);
      slide15.addText([{ text: this.textModule[3].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide16 = pres.addSlide("MASTER_SLIDE");
      slide16.addText([{ text: this.statements[8].statement, options: this.gTitle }], this.gTitlePlace);
      slide16.addChart(pres.charts.BAR, arrayStatementI, this.optionsGraph);

      let slide17 = pres.addSlide("MASTER_SLIDE");
      slide17.addText([{ text: this.statements[9].statement, options: this.gTitle }], this.gTitlePlace);
      slide17.addChart(pres.charts.BAR, arrayStatementJ, this.optionsGraph);

      let slide18 = pres.addSlide("MASTER_SLIDE");
      slide18.addText([{ text: this.statements[10].statement, options: this.gTitle }], this.gTitlePlace);
      slide18.addChart(pres.charts.BAR, arrayStatementK, this.optionsGraph);

      let slide19 = pres.addSlide("MASTER_SLIDE");
      slide19.addText([{ text: this.statements[11].statement, options: this.gTitle }], this.gTitlePlace);
      slide19.addChart(pres.charts.BAR, arrayStatementL, this.optionsGraph);

      let slide20 = pres.addSlide("MASTER_SLIDE");
      slide20.addText([{ text: this.statements[12].statement, options: this.gTitle }], this.gTitlePlace);
      slide20.addChart(pres.charts.BAR, arrayStatementM, this.optionsGraph);

      let slide21 = pres.addSlide("MASTER_SLIDE");
      slide21.addText([{ text: this.statements[13].statement, options: this.gTitle }], this.gTitlePlace);
      slide21.addChart(pres.charts.BAR, arrayStatementN, this.optionsGraph);

      let slide22 = pres.addSlide("MASTER_SLIDE");
      slide22.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide22.addTable(arrayRemarkC, this.optTableRemark);

      //Part D
      let slide23 = pres.addSlide("MASTER_SLIDE");
      slide23.addText([{ text: this.textModule[4].header, options: this.gTitle }], this.gTitlePlace);
      slide23.addText([{ text: this.textModule[4].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide24 = pres.addSlide("MASTER_SLIDE");
      slide24.addText([{ text: this.statements[14].statement, options: this.gTitle }], this.gTitlePlace);
      slide24.addChart(pres.charts.BAR, arrayStatementO, this.optionsGraph);

      let slide25 = pres.addSlide("MASTER_SLIDE");
      slide25.addText([{ text: this.statements[15].statement, options: this.gTitle }], this.gTitlePlace);
      slide25.addChart(pres.charts.BAR, arrayStatementP, this.optionsGraph);

      let slide26 = pres.addSlide("MASTER_SLIDE");
      slide26.addText([{ text: this.statements[16].statement, options: this.gTitle }], this.gTitlePlace);
      slide26.addChart(pres.charts.BAR, arrayStatementQ, this.optionsGraph);

      let slide27 = pres.addSlide("MASTER_SLIDE");
      slide27.addText([{ text: this.statements[17].statement, options: this.gTitle }], this.gTitlePlace);
      slide27.addChart(pres.charts.BAR, arrayStatementR, this.optionsGraph);

      let slide28 = pres.addSlide("MASTER_SLIDE");
      slide28.addText([{ text: this.statements[18].statement, options: this.gTitle }], this.gTitlePlace);
      slide28.addChart(pres.charts.BAR, arrayStatementS, this.optionsGraph);

      let slide29 = pres.addSlide("MASTER_SLIDE");
      slide29.addText([{ text: this.statements[19].statement, options: this.gTitle }], this.gTitlePlace);
      slide29.addChart(pres.charts.BAR, arrayStatementT, this.optionsGraph);

      let slide30 = pres.addSlide("MASTER_SLIDE");
      slide30.addText([{ text: this.statements[20].statement, options: this.gTitle }], this.gTitlePlace);
      slide30.addChart(pres.charts.BAR, arrayStatementU, this.optionsGraph);

      let slide31 = pres.addSlide("MASTER_SLIDE");
      slide31.addText([{ text: this.statements[21].statement, options: this.gTitle }], this.gTitlePlace);
      slide31.addChart(pres.charts.BAR, arrayStatementV, this.optionsGraph);

      let slide32 = pres.addSlide("MASTER_SLIDE");
      slide32.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide32.addTable(arrayRemarkD, this.optTableRemark);

      //Part E
      let slide33 = pres.addSlide("MASTER_SLIDE");
      slide33.addText([{ text: this.textModule[5].header, options: this.gTitle }], this.gTitlePlace);
      slide33.addText([{ text: this.textModule[5].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide34 = pres.addSlide("MASTER_SLIDE");
      slide34.addText([{ text: this.statements[22].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide34.addChart(pres.charts.BAR, arrayStatementW, this.optionsGraph);

      let slide35 = pres.addSlide("MASTER_SLIDE");
      slide35.addText([{ text: this.statements[23].statement, options: this.gTitle }], this.gTitlePlace);
      slide35.addChart(pres.charts.BAR, arrayStatementX, this.optionsGraph);

      let slide36 = pres.addSlide("MASTER_SLIDE");
      slide36.addText([{ text: this.statements[24].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide36.addChart(pres.charts.BAR, arrayStatementY, this.optionsGraph);

      let slide37 = pres.addSlide("MASTER_SLIDE");
      slide37.addText([{ text: this.statements[25].statement, options: this.gTitle }], this.gTitlePlace);
      slide37.addChart(pres.charts.BAR, arrayStatementZ, this.optionsGraph);

      let slide38 = pres.addSlide("MASTER_SLIDE");
      slide38.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide38.addTable(arrayRemarkE, this.optTableRemark);

      //Part F
      let slide39 = pres.addSlide("MASTER_SLIDE");
      slide39.addText([{ text: this.textModule[6].header, options: this.gTitle }], this.gTitlePlace);
      slide39.addText([{ text: this.textModule[6].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide40 = pres.addSlide("MASTER_SLIDE");
      slide40.addText([{ text: this.statements[26].statement, options: this.gTitle }], this.gTitlePlace);
      slide40.addChart(pres.charts.BAR, arrayStatementZA, this.optionsGraph);

      let slide41 = pres.addSlide("MASTER_SLIDE");
      slide41.addText([{ text: this.statements[27].statement, options: this.gTitle }], this.gTitlePlace);
      slide41.addChart(pres.charts.BAR, arrayStatementZB, this.optionsGraph);

      let slide42 = pres.addSlide("MASTER_SLIDE");
      slide42.addText([{ text: this.statements[28].statement, options: this.gTitle }], this.gTitlePlace);
      slide42.addChart(pres.charts.BAR, arrayStatementZC, this.optionsGraph);

      let slide43 = pres.addSlide("MASTER_SLIDE");
      slide43.addText([{ text: this.statements[29].statement, options: this.gTitle }], this.gTitlePlace);
      slide43.addChart(pres.charts.BAR, arrayStatementZD, this.optionsGraph);

      let slide44 = pres.addSlide("MASTER_SLIDE");
      slide44.addText([{ text: this.statements[30].statement, options: this.gTitle }], this.gTitlePlace);
      slide44.addChart(pres.charts.BAR, arrayStatementZE, this.optionsGraph);

      let slide45 = pres.addSlide("MASTER_SLIDE");
      slide45.addText([{ text: this.statements[31].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide45.addChart(pres.charts.BAR, arrayStatementZF, this.optionsGraph);

      let slide46 = pres.addSlide("MASTER_SLIDE");
      slide46.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide46.addTable(arrayRemarkF, this.optTableRemark);

      //Part G
      let slide47 = pres.addSlide("MASTER_SLIDE");
      slide47.addText([{ text: this.textModule[7].header, options: this.gTitle }], this.gTitlePlace);
      slide47.addText([{ text: this.textModule[7].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide48 = pres.addSlide("MASTER_SLIDE");
      slide48.addText([{ text: this.statements[32].statement, options: this.gTitle }], this.gTitlePlace);
      slide48.addChart(pres.charts.BAR, arrayStatementZG, this.optionsGraph);

      let slide49 = pres.addSlide("MASTER_SLIDE");
      slide49.addText([{ text: this.statements[33].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide49.addChart(pres.charts.BAR, arrayStatementZH, this.optionsGraph);

      let slide50 = pres.addSlide("MASTER_SLIDE");
      slide50.addText([{ text: this.statements[34].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide50.addChart(pres.charts.BAR, arrayStatementZI, this.optionsGraph);

      let slide51 = pres.addSlide("MASTER_SLIDE");
      slide51.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide51.addTable(arrayRemarkG, this.optTableRemark);

      //Part H
      let slide52 = pres.addSlide("MASTER_SLIDE");
      slide52.addText([{ text: this.textModule[8].header, options: this.gTitle }], this.gTitlePlace);
      slide52.addText([{ text: this.textModule[8].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide53 = pres.addSlide("MASTER_SLIDE");
      slide53.addText([{ text: this.statements[35].statement, options: this.gTitle }], this.gTitlePlace);
      slide53.addChart(pres.charts.BAR, arrayStatementZJ, this.optionsGraph);

      let slide54 = pres.addSlide("MASTER_SLIDE");
      slide54.addText([{ text: this.statements[36].statement, options: this.gTitle }], this.gTitlePlace);
      slide54.addChart(pres.charts.BAR, arrayStatementZK, this.optionsGraph);

      let slide55 = pres.addSlide("MASTER_SLIDE");
      slide55.addText([{ text: this.statements[37].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide55.addChart(pres.charts.BAR, arrayStatementZL, this.optionsGraph);

      let slide56 = pres.addSlide("MASTER_SLIDE");
      slide56.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide56.addTable(arrayRemarkH, this.optTableRemark);

      //Part I
      let slide57 = pres.addSlide("MASTER_SLIDE");
      slide57.addText([{ text: this.textModule[9].header, options: this.gTitle }], this.gTitlePlace);
      slide57.addText([{ text: this.textModule[9].texta, options: this.TextBlock }], this.TextBlockPlace);

      let slide58 = pres.addSlide("MASTER_SLIDE");
      slide58.addText([{ text: this.statements[38].statement, options: this.gTitleSmall }], this.gTitlePlace);
      slide58.addChart(pres.charts.BAR, arrayStatementZM, this.optionsGraph);

      let slide59 = pres.addSlide("MASTER_SLIDE");
      slide59.addText([{ text: this.statements[39].statement, options: this.gTitle }], this.gTitlePlace);
      slide59.addChart(pres.charts.BAR, arrayStatementZN, this.optionsGraph);

      let slide60 = pres.addSlide("MASTER_SLIDE");
      slide60.addText([{ text: this.statements[40].statement, options: this.gTitle }], this.gTitlePlace);
      slide60.addChart(pres.charts.BAR, arrayStatementZO, this.optionsGraph);

      let slide61 = pres.addSlide("MASTER_SLIDE");
      slide61.addText([{ text: this.statements[41].statement, options: this.gTitle }], this.gTitlePlace);
      slide61.addChart(pres.charts.BAR, arrayStatementZP, this.optionsGraph);

      let slide62 = pres.addSlide("MASTER_SLIDE");
      slide62.addText([{ text: "Uw opmerkingen/overwegingen", options: this.gTitle }], this.gTitlePlace);
      slide62.addTable(arrayRemarkI, this.optTableRemark);

      let filename = "Rapportage_" + this.textModule[0].header + "_" + this.dataext.family_name + ".pptx";
      // eslint-disable-next-line no-undef
      pres.writeFile({ fileName: filename });
      this.disableBtn = false;
    },
  },
  computed: {
    ...mapGetters("fchartCresult", ["cstoremodules"]),
    ...mapGetters("colors", ["colors"]),
    ...mapGetters("cmain", ["statements"]),
  },
  created() {
    this.$store.dispatch("cmain/getMains");
    this.getData();
  },
};
</script>

<style scoped></style>
